export default __webpack_public_path__ + "images/about-bg.png?2e99e5bf2e0d6bd5831a060cd40b9788";